import React, { useState } from 'react';
import { components } from 'react-select';
import { FaChevronDown, FaChevronUp, FaFolder, FaRegFileAlt } from 'react-icons/fa';

const CustomMenuList = ({ isDark, ...props }) => {
  const [openGroup, setOpenGroup] = useState(null);

  return (
    <components.MenuList {...props}>
      {props.options.map((group, index) => {
        const isOpen = openGroup === index;

        // Renderiza recursivamente los nodos hijos con mejor visualización
        const renderOptions = (options, level = 0) => {
          return options.map((option, idx) => {
            const isLeaf = !option.children || option.children.length === 0;
            const indent = 20 * level;
            const borderLeft = level > 0 ? `2px solid ${isDark === 'true' ? '#374954' : '#e0e0e0'}` : 'none';
            const baseBg = isDark === 'true' ? '#232d36' : '#f7fafd';
            const hoverBg = isDark === 'true' ? '#374954' : '#e3f0fa';
            if (!isLeaf) {
              return (
                <div key={option.id} style={{ marginLeft: indent, borderLeft, paddingLeft: 8, marginTop: 4 }}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 8,
                      fontWeight: 700,
                      fontSize: 15,
                      padding: '7px 12px',
                      color: isDark === 'true' ? '#b2e0ff' : '#1a3a4a',
                      backgroundColor: baseBg,
                      cursor: 'default',
                      borderRadius: 6,
                      border: `1px solid ${isDark === 'true' ? '#263238' : '#e0e0e0'}`,
                      boxShadow: '0 1px 2px rgba(0,0,0,0.03)',
                    }}
                  >
                    <FaFolder style={{ opacity: 0.7 }} />
                    {option.label}
                  </div>
                  {renderOptions(option.children, level + 1)}
                </div>
              );
            } else {
              return (
                <div
                  key={option.id}
                  onClick={() => props.selectOption(option)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    padding: '7px 18px',
                    fontWeight: 500,
                    fontSize: '14px',
                    color: isDark === 'true' ? '#fff' : '#333',
                    backgroundColor: baseBg,
                    cursor: 'pointer',
                    marginLeft: indent,
                    borderLeft,
                    borderRadius: 6,
                    marginTop: 4,
                    border: `1px solid ${isDark === 'true' ? '#263238' : '#e0e0e0'}`,
                    boxShadow: '0 1px 2px rgba(0,0,0,0.03)',
                    transition: 'background 0.2s, color 0.2s',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = hoverBg;
                    e.currentTarget.style.color = isDark === 'true' ? '#b2e0ff' : '#1a3a4a';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = baseBg;
                    e.currentTarget.style.color = isDark === 'true' ? '#fff' : '#333';
                  }}
                >
                  <FaRegFileAlt style={{ opacity: 0.7 }} />
                  {option.label}
                </div>
              );
            }
          });
        };

        return (
          <div key={group.label}>
            <div
              onClick={() => setOpenGroup(isOpen ? null : index)}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '10px 14px',
                cursor: 'pointer',
                backgroundColor: isDark === 'true' ? '#263238' : '#e0e0e0',
                color: isDark === 'true' ? '#fff' : '#333',
                fontWeight: 600,
                borderRadius: 4,
              }}
            >
              {group.label}
              {isOpen ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
            </div>
            {isOpen && renderOptions(group.options)}
          </div>
        );
      })}
    </components.MenuList>
  );
};

export default CustomMenuList;
